import PropTypes from 'prop-types';

const CarouselItem = ({ children }) => {
    return (
        <>
            { children }
        </>
    );
};

CarouselItem.propTypes = {
    children: PropTypes.any.isRequired
};

export default CarouselItem;
